module.exports = __webpack_public_path__ + "img/sixpackcarrier81.e7b3586a.jpg";